import script from "./VerifyOPT.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyOPT.vue?vue&type=script&setup=true&lang=js"

import "./VerifyOPT.vue?vue&type=style&index=0&id=8f6f5378&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f6f5378"]])

export default __exports__